import { render, staticRenderFns } from "./SalesControl.vue?vue&type=template&id=8aeff192&scoped=true&"
import script from "./SalesControl.vue?vue&type=script&lang=js&"
export * from "./SalesControl.vue?vue&type=script&lang=js&"
import style0 from "./SalesControl.vue?vue&type=style&index=0&id=8aeff192&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aeff192",
  null
  
)

export default component.exports